import { useFragment, graphql } from "react-relay";

import { useFormattedDate$key } from "./__generated__/useFormattedDate.graphql";
import {
  FormattedDateStyle,
  useFormattedDateRaw,
  useFormattedDateRawInWorkSpaceTimeZone,
} from "./useFormattedDateRaw";

const FRAGMENT = graphql`
  fragment useFormattedDate on Date {
    isoString
  }
`;
export function useFormattedDate(
  _date: useFormattedDate$key,
  style?: FormattedDateStyle
) {
  const date = useFragment(FRAGMENT, _date);

  return useFormattedDateRaw(date.isoString, style ?? "DEFAULT");
}

export function useFormattedDateInWorkspaceTimeZone(
  _date: useFormattedDate$key,
  style?: FormattedDateStyle
) {
  const date = useFragment(FRAGMENT, _date);

  return useFormattedDateRawInWorkSpaceTimeZone(
    date.isoString,
    style ?? "DEFAULT"
  );
}
